/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';

interface TemplateLanguageCountIconArgs {
  itemName: string;
  translations?: TemplateModel[];
  action?: ActionModel;
  showMidDot?: boolean;
}

export default class TemplateLanguageCountIcon extends Component<TemplateLanguageCountIconArgs> {
  get languageCount(): number {
    if (this.args.translations != null) {
      return this.getTemplatesLanguageCount();
    } else {
      return this.getActionsLanguageCount();
    }
  }

  getTemplatesLanguageCount() {
    return this.args.translations?.length ?? 0;
  }

  getActionsLanguageCount() {
    return this.args.action?.campaign?.getLanguageCountByMessagingAction(this.args.action.id) ?? 0;
  }
}
